<template>
    <AppPageLoader v-if="$store.state.isSwitchingOrg" text="Switching organization..." />
    <div v-else-if="isParentOrIndvidual">
        <router-view v-slot="{ Component }">
            <component :is="Component" :key="$route.query.orgId" myTestProp="this is a test prop" :account="storeAccount" @setAccount="$emit('setAccount', $event)" />
        </router-view>
    </div>
    <div v-else style="overflow-y: hidden; overflow-x: hidden; ">

        <div v-if="$store.getters.viewingAsSuper"
             style="width: 100%; background-color: #e3f2fd; height: 40px; display: flex; justify-content: center; align-items: center; border-bottom: 1px solid var(--main-border-color)">
            <div style="flex: 1; justify-content: center; display: flex; color: #757575">
                🧑‍🚀 Viewing <span style="font-weight: 600; color: black" class="ml-2 mr-2">{{storeOrganization.name}}</span> as Internal Sway Admin
                <AppChip color="red" small class="ml-2" v-if="isDisabledOrganization">Disabled Organization {{disabledDateString}}</AppChip>
            </div>

            <v-menu
                    location="bottom"
                    open-on-hover
                    v-if="$store.getters.availableOrganizations"
                    max-height="500px"
            >
                <template v-slot:activator="{ props }">
                    <div v-bind="props" style="font-weight: bold; color: black; cursor: pointer" class="pr-2">
                        EXIT
                    </div>
                </template>

                <app-card
                        class="mx-auto"
                        :min-width="300"
                        hide-header
                >
                    <v-divider></v-divider>

                    <v-list v-if="$store.getters.availableOrganizations">
                        <v-list-item
                                v-for="(item, i) in $store.getters.availableOrganizations"
                                :key="i"
                                @click="changeOrganization(item)"
                                class="account-dropdown-list-item"
                                :title="item.name"
                        >
                        </v-list-item>
                    </v-list>
                    <v-divider></v-divider>
                </app-card>

            </v-menu>
            <div v-else style="margin-right: 20px; font-weight: bold; color: black" @click="changeOrganization(storeOrganization)">
                EXIT
            </div>
        </div>

        <div v-else-if="$store.getters.isEnterpriseAdminOrg"
             style="width: 100%; background-color: #34d3fe; height: 40px; display: flex; justify-content: center; align-items: center">
            <div style="flex: 1; justify-content: center; display: flex">
                Viewing <span style="color: #fafafa; font-weight: 600" class="ml-2 mr-2">{{storeOrganization.name}}</span> as Management Admin
            </div>
        </div>
        <div v-if="isAccountPastDue"
             style="width: 100%; background-color: #fdf8f1; height: 70px; padding: 1rem; display: flex; align-items: center; border-bottom: 1px solid var(--main-border-color)">
            <div style="font-weight: bold">
                Your account is past due
            </div>

            <div style="padding: 0 1rem; color: #222222">
                To avoid issues accessing and using your account, please make a payment. If payment has already been submitted, please be aware that processing may take a few days.
                <br />

                <div style="font-size: .8em">If you have any questions, please reach out to <a href="mailto:help@healthyroster.com" style="color: blue">help@healthyroster.com</a>.</div>
            </div>
            <div style="flex: 1"></div>
            <AppBtn small @click="$router.push(`/billing/billing-history`)">View Invoices</AppBtn>


        </div>
        <div v-if="isOverUsageLimit"
             style="width: 100%; background-color: #fdf8f1; height: 70px; padding: 1rem; display: flex; align-items: center; border-bottom: 1px solid var(--main-border-color)">
            <div style="font-weight: bold">
                Profile usage limit exceeded
            </div>

            <div style="padding: 0 1rem; color: #222222">
                Your organization has used {{ profilesUsed }} of {{ profilesPurchased }} purchased profiles for the current subscription period. Additional usage may result in overage charges.
                <br />

                <div v-if="usageLastCalculatedOnDisplay" style="font-size: .8em; font-style: italic; color: #555">
                    *Usage numbers are as of {{ usageLastCalculatedOnDisplay }}. Actual current usage may be higher. Click "View Usage" to get the most up-to-date numbers.
                </div>
                <div style="font-size: .8em">To increase your limit or ask questions, please reach out to <a href="mailto:help@healthyroster.com" style="color: blue">help@healthyroster.com</a>.</div>
            </div>
            <div style="flex: 1"></div>
            <AppBtn small @click="$router.push(`/billing/billing-overview`)">View Usage</AppBtn>
        </div>
        <div id="app" v-if="storeAccount">

            <div class="sidebar-container" :style="sidebarHeightStyle">
                <!--                <SidebarLeft :company="company"/>-->
                <SidebarLeft :company="company"/>
            </div>
            <div>
                <div class="top-bar">
                    <!--                    <navbar-top  />-->
                    <NavbarTop />
                </div>
                <div>

                </div>

                <div class="main-content" :style="mainContentHeightStyle">
                    <app-breadcrumbs :path="routePath"></app-breadcrumbs>
                    <router-view v-slot="{ Component }">
                        <component :is="Component" :key="$route.query.orgId" myTestProp="this is a test prop" :account="storeAccount" @setAccount="$emit('setAccount', $event)" />
                    </router-view>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

// import NavbarTop from "@/components/NavbarTop";
import {isSuperView, switchSelectedOrganization, isPatient} from '@/services/userService'
// import NavbarTop from "@/components/NavbarTop";
import Highcharts from 'highcharts'
import {swayThemes} from "@/config/themes"
// import SidebarLeft from "@/components/SidebarLeft";
import SidebarLeft from "@/components/SidebarLeft";
import NavbarTop from "@/components/NavbarTop";
import AppPageLoader from "@/components/AppPageLoader";
import {getInvoices, getCurrentProfileUsage} from "@/services/billing.service";
import {isAdminOrgAccessType} from "@/js/shared/helper";
import {SET_IS_SWITCHING_ORG} from "@/store/mutation-types";
import moment from "moment";

export default {
    name: 'DashboardLayout',
    emits: ['setAccount'],
    // props: {
    //     account: Object
    // },
    components: {
        NavbarTop,
        SidebarLeft,
        AppPageLoader,
        // SidebarLeft,
        // NavbarTop,

    },
    data: () => ({
        company: 'sway',
        theme: 'light',
        // isSuperView: false,
        isAccountPastDue: false,
        isOverUsageLimit: false,
        profilesUsed: 0,
        profilesPurchased: 0,
        // ISO timestamp of the oldest snapshot summed into ProfilesUsed — drives the
        // "*Usage numbers are as of ..." disclaimer in the over-usage banner.
        usageLastCalculatedOn: null,
        // Track the org id we've already fetched banner state for so we don't refire
        // the past-due / over-usage checks on every spurious store mutation. Resets
        // implicitly when the user switches orgs (different id → checks rerun).
        lastCheckedOrgId: null,
    }),
    created() {

    },
    watch: {
        // App.vue's async mounted hydrates currentAccount/currentOrganization from
        // API/storage; DashboardLayout was previously hitting mounted() before that
        // finished, so the banner checks silently no-op'd (or threw on isPatient()).
        // Watching both with immediate:true means the checks fire as soon as both
        // sides of the store are populated — and rerun naturally on org switch.
        storeAccount: { immediate: true, handler() { this.runOrgBannerChecks(); } },
        '$store.getters.selectedOrganizationId': { immediate: true, handler() { this.runOrgBannerChecks(); } },
    },
    computed: {
        routePath() {
            return this.$route?.path || ''
        },
        storeAccount() {
            return this.$store.state.currentAccount
        },
        storeOrganization() {
            return this.$store.state.currentOrganization
        },
        isDisabledOrganization() {
            return this.$store.state.currentOrganization.isDisabled
        },
        disabledDateString() {
            return this.$store.state.currentOrganization.disabledDate
        },
        isSuperView() {
            return isSuperView();
        },
        isParentOrIndvidual() {
            return isPatient();
        },
        // Total px reserved by banners stacked above the main layout (super view, past due, usage limit)
        bannerOffsetPx(){
            let offset = 0;
            if (this.isSuperView) offset += 40;
            if (this.isAccountPastDue) offset += 70;
            if (this.isOverUsageLimit) offset += 70;
            return offset;
        },
        sidebarHeightStyle(){
            return { height: `calc(100vh - ${this.bannerOffsetPx}px)` };
        },
        mainContentHeightStyle(){
            // 72px reserved for the top bar
            return { height: `calc(100vh - 72px - ${this.bannerOffsetPx}px)` };
        },
        usageLastCalculatedOnDisplay(){
            if (!this.usageLastCalculatedOn) return null;
            // Render in the user's local time. moment converts the ISO timestamp; the
            // banner copy uses the form "May 26, 2026 at 3:05am".
            return moment.utc(this.usageLastCalculatedOn).local().format('MMMM D, YYYY [at] h:mma');
        }
    },
    methods: {
        onLightDarkChange() {
            this.$vuetify.theme.dark = !this.$vuetify.theme.dark
        },
        setTheme() {
            let newTheme = swayThemes;

            let darkKeys = Object.keys(newTheme.dark)
            darkKeys.forEach(key => {
                this.$vuetify.theme.themes.dark[key] = newTheme.dark[key]
            })
            let lightKeys = Object.keys(newTheme.light)
            lightKeys.forEach(key => {
                this.$vuetify.theme.themes.light[key] = newTheme.light[key]
            });

        },
        runOrgBannerChecks() {
            // Both checks depend on currentAccount + currentOrganization being hydrated;
            // bail if either is missing. The watcher will re-fire when they arrive.
            if (!this.storeAccount) return;
            const orgId = this.$store.getters.selectedOrganizationId;
            if (!orgId) return;
            
            // Dedupe: don't refire for the same org on noisy store updates. A real org
            // switch produces a different id and we re-run as intended.
            if (orgId === this.lastCheckedOrgId) return;
            if (this.isParentOrIndvidual) return;
            this.lastCheckedOrgId = orgId;
            
            // Reset banner state up front so a stale "true" from the previous org
            // doesn't persist if the new org is healthy.
            this.isAccountPastDue = false;
            this.isOverUsageLimit = false;
            this.profilesUsed = 0;
            this.profilesPurchased = 0;
            this.usageLastCalculatedOn = null;
            this.checkIfPastDueInvoice();
            this.checkIfOverUsageLimit();
        },
        async checkIfPastDueInvoice() {
            if (this.isParentOrIndvidual || !this.storeAccount) return

            if (this.$store.getters.isOrgAdmin || this.$store.getters.isSuperAdmin || this.$store.getters.isBillingContact){
                // Show banner on dashboard if the organization has a past due invoice
                let response = await getInvoices();
                let isAccountPastDue = false
                if (response.isSuccess) {
                    response.invoices.forEach(x => x.isOverdue ? isAccountPastDue = true : null)
                }
                this.isAccountPastDue = isAccountPastDue
            }
        },
        async checkIfOverUsageLimit() {
            if (this.isParentOrIndvidual || !this.storeAccount) return

            if (this.$store.getters.isOrgAdmin || this.$store.getters.isSuperAdmin || this.$store.getters.isBillingContact) {
                // Capture the org id at request time so we can compare against the
                // response's OrganizationId — if the user switched orgs mid-flight the
                // response belongs to a different org and we must discard it (otherwise
                // the banner can flash with the prior org's usage data).
                const requestedOrgId = this.$store.getters.selectedOrganizationId;
                let response = await getCurrentProfileUsage();
                if (!response) return;
                if (response.organizationId !== requestedOrgId) return;
                if (this.$store.getters.selectedOrganizationId !== requestedOrgId) return;

                if (response.sportsUsage && response.sportsUsage.shouldAlert){
                    this.isOverUsageLimit = true
                    this.profilesUsed = response.sportsUsage.profilesUsed
                    this.profilesPurchased = response.sportsUsage.profilesPurchased
                    this.usageLastCalculatedOn = response.sportsUsage.lastCalculatedOn
                }
                if (response.clinicalUsage && response.clinicalUsage.shouldAlert){
                    this.isOverUsageLimit = true
                    this.profilesUsed = response.clinicalUsage.profilesUsed
                    this.profilesPurchased = response.clinicalUsage.profilesPurchased
                    this.usageLastCalculatedOn = response.clinicalUsage.lastCalculatedOn
                }
            }
        },
        async changeOrganization(organization) {
            // Show a clean loader during the entire switch+navigate operation. Without this,
            // Vuex updates before the URL/route does, which makes the layout briefly render
            // the new org's chrome around the old org's route content (most visible when
            // moving between Enterprise and non-Enterprise dashboards).
            this.$store.commit(SET_IS_SWITCHING_ORG, true);
            try {
                await switchSelectedOrganization(organization.id);
                await this.$router.push(`/dashboard?orgId=${organization.id}`);
            } finally {
                this.$store.commit(SET_IS_SWITCHING_ORG, false);
            }
        },

    },
};
</script>
<style scoped>
#app {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    display: flex;
}

body {
    overflow: hidden;
}

.sidebar-container {
    position: -webkit-sticky;
    position: sticky;
    width: 260px;
}

.main-content {
    width: calc(100vw - 260px);
    padding: 32px 48px;
    overflow-y: scroll;
    background-color: #F9FAFB;
}

.top-bar {
    height: 72px;
    width: calc(100vw - 260px);
}

.theme-picker {
    position: fixed;
    bottom: 10px;
    right: 20px;
}
</style>
